import React from "react";
import Preloader from "../../helper/Preloader";
import ColorInit from "../../helper/ColorInit";
import BottomFooter from "../../components/BottomFooter";
import ThankYouPage from "../../components/thankyou/ThankYouPage";
import ScrollToTop from "react-scroll-to-top";
import HeaderOne from "../../components/HeaderOne";
import FooterOne from "../../components/FooterOne";

const ThankYou = () => {
    return (
        <>
            {/* Preloader */}
            <Preloader />

            {/* ScrollToTop */}
            <ScrollToTop smooth color="#299E60" />

            {/* ColorInit */}
            <ColorInit color={false} />

            {/* HeaderOne */}
            <HeaderOne />

            {/* ThankYouPage */}
            <ThankYouPage />

            {/* FooterOne */}
            <FooterOne />

            {/* BottomFooter */}
            <BottomFooter />
        </>
    );
};

export default ThankYou;

 
